export const KeySeparator = () => {
  return (
    <span className="text-center text-[10px] font-normal leading-height-2 tracking-spacing-2 font-code text-core-silver-a9 mx-layout-spacing-5">
      Then
    </span>
  );
};
